import {Component, OnInit, input} from '@angular/core';
import {Store} from '@ngrx/store';
import {UserService} from '../../user/user.service';

import * as DemoActions from './../store/demo.actions';
import * as fromApp from '../../store/app.reducers';
import * as fromProfile from '../../profile/store/profile.reducers';
import {Observable} from 'rxjs';
import {Demo} from '../demo.model';

@Component({
    selector: 'app-demo-add',
    templateUrl: './demo-add.component.html',
    styleUrls: ['./demo-add.component.scss'],
    standalone: false
})
export class DemoAddComponent implements OnInit {

  readonly type = input<number>(undefined);

  constructor(
    private store: Store<fromApp.AppState>,
    private userService: UserService
  ) { }

  ngOnInit() {
  }

  isAdmin(): Observable<boolean> {
    return this.userService.isAdmin();
  }

  addAudit() {
    const credentials = {};
    if (+this.type() === 1) {
      const s = this.store.select('profile').subscribe(
        (state: fromProfile.State) => {
          credentials['audit'] = state.audit;
          credentials['score'] = state.score;
          credentials['profileDetail'] = state.profileDetail;
          credentials['profileProgress'] = state.profileProgress;
          credentials['audienceStat'] = state.audienceStat;
          credentials['followerStat'] = state.followerStat;
          credentials['followerEngage'] = state.followerEngage;
          credentials['followerEngageIndicator'] = state.followerEngageIndicator;
          credentials['mediaStat'] = state.mediaStat;
          credentials['mediaAnalyze'] = state.mediaAnalyze;
          credentials['mediaCommentAnalyze'] = state.mediaCommentAnalyze;
          credentials['audienceInterest'] = state.audienceInterest;
          credentials['audienceLocation'] = state.audienceLocation;
          const demo = new Demo(null, 1, 1, null, credentials);
          this.store.dispatch(
            new DemoActions.AddDemoAudit(demo)
          );
        }

      );
      s.unsubscribe();
    }
  }

}
